import {Inject, Injectable, DOCUMENT} from '@angular/core';

import {Point} from '@angular/cdk/drag-drop';

@Injectable({
    providedIn: 'root'
})
export class IdentifyFeaturesService {
    title = 'IdentifyFeaturesService';

    headerHeight = 42;

    positionX: number = -1;

    positionY: number = -1;

    constructor(@Inject(DOCUMENT) private document: Document) {}

    setPosition() {
        console.debug(`${this.title} - setPosition`);

        const widgetElt = this.document.getElementById('identifyFeatures');
        if (!widgetElt) {
            return;
        }

        const mapElt = this.document.getElementById('mainMap_root');
        if (!mapElt) {
            return;
        }

        if (
            this.positionX === -1 ||
            this.positionY === -1 ||
            this.positionX + widgetElt.offsetWidth > mapElt.offsetWidth ||
            this.positionY + widgetElt.offsetHeight - this.headerHeight > mapElt.offsetHeight
        ) {
            this.positionX = mapElt.offsetWidth / 2 - widgetElt.offsetWidth / 2;
            this.positionY = mapElt.offsetHeight - widgetElt.offsetHeight + this.headerHeight;
        }

        widgetElt.style.left = `${this.positionX}px`;
        widgetElt.style.top = `${this.positionY}px`;
    }

    updatePositionFromDragPosition(dragPosition: Point) {
        const mapElt = this.document.getElementById('mainMap_root');
        if (!mapElt) {
            return;
        }
        const mapRect = mapElt.getBoundingClientRect();
        this.positionX = dragPosition.x - mapRect.x;
        this.positionY = dragPosition.y - mapRect.y + this.headerHeight;
    }
}
